import Header from "./componentes/Header";
import "./App.css";
import Calculadora from "./componentes/Calculadora";

function App() {
  return (
    <div className="app">
      <Header />
      <Calculadora />
    </div>
  );
}

export default App;
